import Vue from 'vue'
import Router from 'vue-router'
import home from './../components/home'

Vue.use(Router)
let title = document.getElementsByTagName('title')[0];
const router = new Router({
    mode: 'hash',
    routes: [
        {
            path: '/liveDetails/:id',
            name: 'liveDetails',
            component: resolve => require(['@/components/liveDetails'],resolve),
            beforeEnter: (to, from, next) => {
                title.innerText = ' 体育直播-意甲比赛直播观看_德甲在线直播平台_英超免费在线直播_NBA比赛直播网站';
                next();
            },
        },
      // 兼容h5端分享直播间功能，h5端直播间路由是/detail?id=xxxx
      {
        path: '/detail',
        name: 'detail',
        component: resolve => require(['@/components/liveDetails'],resolve),
        beforeEnter: (to, from, next) => {
          debugger
          title.innerText = ' 体育直播-意甲比赛直播观看_德甲在线直播平台_英超免费在线直播_NBA比赛直播网站';
          next({ path: '/liveDetails/' + to.query.id });
        },
      },
        {
            path: '/live',
            name: 'live',
            component: resolve => require(['@/components/live'],resolve),
            beforeEnter: (to, from, next) => {
                title.innerText = ' 主播|赛事直播_足球直播_篮球直播_NBA直播-体育直播';
                next();
            },
        },
        {
            path: '/download',
            name: 'download',
            component: resolve => require(['@/components/download'],resolve),
            beforeEnter: (to, from, next) => {
                title.innerText = ' 下载APP|赛事直播_足球直播_篮球直播_NBA直播-体育直播';
                next();
            },
        },
      {
        path: '/iosAppGuide',
        name: 'iosAppGuide',
        component: resolve => require(['@/components/iosAppGuide/index'],resolve),
        beforeEnter: (to, from, next) => {
          title.innerText = ' 下载APP|赛事直播_足球直播_篮球直播_NBA直播-皮球直播';
          next();
        },
      },
        {
            path: '/information',
            name: 'information',
            component: resolve => require(['@/components/information'],resolve),
            beforeEnter: (to, from, next) => {
                title.innerText = ' 下载APP|赛事直播_足球直播_篮球直播_NBA直播-体育直播';
                next();
            },
        },
        {
            path: '/subscription',
            name: 'subscription',
            component: resolve => require(['@/components/subscription'],resolve),
            beforeEnter: (to, from, next) => {
                title.innerText = ' 订阅|赛事直播_足球直播_篮球直播_NBA直播-体育直播';
                next();
            },
        },
        {
            path: '/competition',
            name: 'competition',
            component: resolve => require(['@/components/competition'],resolve),
            beforeEnter: (to, from, next) => {
                title.innerText = ' 赛程|赛事直播_足球直播_篮球直播_NBA直播-体育直播';
                next();
            },
        },
        {
            path: '/advisory',
            name: 'advisory',
            component: resolve => require(['@/views/Advisory/index.vue'],resolve),
            beforeEnter: (to, from, next) => {
                title.innerText = '资讯';
                next();
            },
        },
        {
            path: '/advisoryDetails',
            name: 'advisoryDetails',
            component: resolve => require(['@/views/AdvisoryDetails/index.vue'],resolve),
            beforeEnter: (to, from, next) => {
                title.innerText = '资讯详情';
                next();
            },
        },
        {
            path: '/personal',
            name: 'personal',
            component: resolve => require(['@/components/personal'],resolve),
            beforeEnter: (to, from, next) => {
                title.innerText = ' 体育直播-意甲比赛直播观看_德甲在线直播平台_英超免费在线直播_NBA比赛直播网站';
                next();
            },
        },
        {
            path: '/announcementDetails/:id',
            name: 'announcementDetails',
            component: resolve => require(['@/components/announcementDetails'],resolve),
            beforeEnter: (to, from, next) => {
                title.innerText = ' 体育直播-意甲比赛直播观看_德甲在线直播平台_英超免费在线直播_NBA比赛直播网站';
                next();
            },
        },
        {
            path: '/myLiving',
            name: 'myLiving',
            component: resolve => require(['@/components/myLiving'],resolve),
            beforeEnter: (to, from, next) => {
                title.innerText = ' 体育直播-意甲比赛直播观看_德甲在线直播平台_英超免费在线直播_NBA比赛直播网站';
                next();
            },
        },
        {
            path: '*',
            name: 'home',
            component:home,
            beforeEnter: (to, from, next) => {
                title.innerText = ' 体育直播-意甲比赛直播观看_德甲在线直播平台_英超免费在线直播_NBA比赛直播网站';
                next();
            },
        },
    ]
})

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js